import React, { useState, useRef, useEffect } from 'react';
import ReactToPrint from "react-to-print";
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';

import CSConfigUtil from '../util/CSConfigUtil'; 
import CSServiceUtil from '../util/CSServiceUtil'; 
import CSRequestUtil from '../util/CSRequestUtil'; 
import CSUtil from "../util/CSUtil";

const mServiceUtil = CSServiceUtil.cfGetInstance();

const CSGoodsReceipt1 = (lProps) =>
{
    const mComponentRef = useRef(null);
    const [ mFormTitle, setFormTitle ] = useState('Goods Receipt Note');
    const [ mCompanyDetails, setCompanyDetails ] = useState(
        {
            mCompanyName: '',
            mAddress1   : '',
            mAddress2   : '',
            mPhone1     : '',
            mPhone2     : '',
            mEmail      : '',
            mWebsite    : '',
            mLogo       : ''
        }, []
    );

    const [ mVendorDetails, setVendorDetails ] = useState(
        {
            mTitle          : 'Consignor',
            mVendorName     : '', 
            mVendorAddress  : '', 
            mContactPerson  : '', 
            mContactNumber  : '', 
            mGstNo          : '',
            mPhoneNumber    : '',
            mEmail          : '',
        }, []
    );

    const [ mConsigneeDetails, setConsigneeDetails ] = useState(
        {
            mTitle             : 'Consignee',
            mConsigneeName     : '',
            mAddress           : '', 
            mDeliveryAddress   : '', 
            mContactPerson     : '', 
            mContactNumber     : '', 
            mPhoneNumber       : '', 
            mGstNo             : '',
            mEmail             : ''
        }, [lProps]
    );

    const [ mGoodsReceipt, setGoodsReceipt ] = useState(
        {
            mGoodsReceiptNo    : '',
            mGoodsReceiptDate  : '',
            mVendorDcNo       : '',
            mPOList     : '',
            mGRNTitle          : 'Stock Inward Items'
        }
    );

    const [ mGoodsReceiptItems, setGoodsReceiptItems ] = useState(null);

    const [ mServiceCode, setServiceCode] = useState(null);
    const [ mRequestId, setRequestId] = useState(null);

    const [ mFooter, setFooter ] = useState("Goods Receipt Note is a computer generated document.");

    useEffect(() =>
        { 
            const fnInitializeForm = () =>
            {
                if(lProps && lProps.pCriteria && lProps.pFormType && lProps.pFormProperties)
                {
                    for(var lInd=0; lInd<lProps.pFormProperties.length;lInd++)
                    {
                        var lPropObj = lProps.pFormProperties[lInd];
                        if(lPropObj.type_ === 'initialize')
                        {
                            const lValue = lPropObj.value_;
                            if(lPropObj.property_ === 'form_title_')
                            {
                                setFormTitle(lValue);
                            }
                            else if(lPropObj.property_ === 'vendor_section_title_')
                            {
                                setVendorDetails(lPrevState => { return { ...lPrevState, mTitle : lValue } });
                            }
                            else if(lPropObj.property_ === 'consignee_section_title_')
                            {
                                setConsigneeDetails(lPrevState => { return { ...lPrevState, mTitle : lValue } });
                            }
                            else if(lPropObj.property_ === 'request_id_')
                            {
                                setRequestId(lValue);
                            }
                            else if(lPropObj.property_ === 'service_code_')
                            {
                                setServiceCode(lValue);
                            }
                            else if(lPropObj.property_ === 'footer_')
                            {
                                setFooter(lValue);
                            }
                        }
                    }
                }
            }

            fnInitializeForm();
        }, [lProps, setConsigneeDetails, setVendorDetails]
    );

    useEffect(() =>
        {
            const fnInitializeData = () =>
            {
                if(mServiceCode && lProps.pCriteria)
                {
                    var lServiceObject = mServiceUtil.cfGetServiceObject(mServiceCode);
                    if(lServiceObject)
                    {
                        var lCriteria = lProps.pCriteria;
                        lCriteria.office_code_ = CSConfigUtil.mOfficeCode;
                        var lRequestUtil = new CSRequestUtil('GET', mServiceCode, lServiceObject.type_, mRequestId, lServiceObject);
                        lRequestUtil.cfSetRequestCriteria(lCriteria);
                        lRequestUtil.cfProcessRequest((lResponse) =>
                            {
                                if(lResponse)
                                {
                                    if(lResponse.hasOwnProperty('consignee_details_') && (lResponse.consignee_details_.length > 0))
                                    {
                                        var lConsigneeDetails = lResponse.consignee_details_[0];
                                        setConsigneeDetails(lPrvState => 
                                            { 
                                                return { 
                                                    ...lPrvState,
                                                    mConsigneeName     : lConsigneeDetails.consignee_name_, 
                                                    mAddress           : lConsigneeDetails.address_, 
                                                    mDeliveryAddress   : lConsigneeDetails.delivery_address_, 
                                                    mContactPerson     : lConsigneeDetails.contact_person_, 
                                                    mContactNumber     : lConsigneeDetails.contact_number_, 
                                                    mPhoneNumber       : lConsigneeDetails.phone_no_, 
                                                    mGstNo             : lConsigneeDetails.gst_no_,
                                                    mEmail             : lConsigneeDetails.email_
                                                } 
                                            }
                                        );
                                    }

                                    if(lResponse.hasOwnProperty('company_details_') && (lResponse.company_details_.length > 0))
                                    {
                                        let lCompanyInfo = lResponse.company_details_[0];
                                        let lCompanyDetails = {};

                                        lCompanyDetails.mCompanyName = lCompanyInfo.office_name_;
                                        lCompanyDetails.mAddress1    = lCompanyInfo.address_1_;
                                        lCompanyDetails.mAddress2    = lCompanyInfo.address_2_;
                                        lCompanyDetails.mPhone1      = lCompanyInfo.office_phone_1_;
                                        lCompanyDetails.mPhone2      = lCompanyInfo.office_phone_2_;
                                        lCompanyDetails.mEmail       = lCompanyInfo.email_;
                                        lCompanyDetails.mWebsite     = lCompanyInfo.website_;
                                        lCompanyDetails.mLogo        = lCompanyInfo.logo_;

                                        setCompanyDetails(lCompanyDetails);
                                    }

                                    if(lResponse.hasOwnProperty('vendor_details_') && (lResponse.vendor_details_.length > 0))
                                    {
                                        var lVendorDetails = lResponse.vendor_details_[0];
                                        setVendorDetails(lPrevState => 
                                            { 
                                                return { 
                                                    ...lPrevState,
                                                    mVendorName        : lVendorDetails.vendor_name_, 
                                                    mVendorAddress     : lVendorDetails.vendor_address_, 
                                                    mContactPerson     : lVendorDetails.contact_person_, 
                                                    mContactNumber     : lVendorDetails.contact_number_, 
                                                    mPhoneNumber       : lVendorDetails.phone_no_, 
                                                    mGstNo             : lVendorDetails.gst_no_,
                                                    mEmail             : lVendorDetails.email_
                                                }
                                            }
                                        );
                                    }

                                    if(lResponse.hasOwnProperty('goods_receipt_') && (lResponse.goods_receipt_.length > 0))
                                    {
                                        var lGoodsReceipt = lResponse.goods_receipt_[0];
                                        setGoodsReceipt(lPrevState =>
                                            {
                                                return {
                                                    ...lPrevState,
                                                    mGoodsReceiptNo    : lGoodsReceipt.goods_receipt_no_,
                                                    mVendorDcNo        : lGoodsReceipt.vendor_dc_no_,
                                                    mGoodsReceiptDate  : lGoodsReceipt.received_date_,
                                                    mPOList            : lGoodsReceipt.po_num_
                                                }
                                            }
                                        );
                                    }

                                    if(lResponse.hasOwnProperty('goods_receipt_items_') && (lResponse.goods_receipt_items_.length > 0))
                                    {
                                        var lDataCollection = [];
                                        var lrcInd          = 0;
                                        var lTotalQuantity  = 0;
                                        for(var ldInd=0; ldInd<lResponse.goods_receipt_items_.length; ldInd++)
                                        {
                                            var lDataObj = lResponse.goods_receipt_items_[ldInd];
                                            var lColDataList = [];
                                            lColDataList.push(<td key={lrcInd++}>               {ldInd + 1}                     </td>);
                                            lColDataList.push(<td key={lrcInd++}>               {lDataObj.sku_code_}            </td>);
                                            lColDataList.push(<td key={lrcInd++}>               {lDataObj.item_name_}           </td>);
                                            lColDataList.push(<td key={lrcInd++}>               {lDataObj.item_description_}    </td>);
//                                            lColDataList.push(<td align="right" key={lrcInd++}> {lDataObj.order_qty_}           </td>);
                                            lColDataList.push(<td align="right" key={lrcInd++}> {lDataObj.receipt_qty_}         </td>);
                    
                                            lTotalQuantity += Number(lDataObj.receipt_qty_);
                                            lDataCollection.push(<tr key={ldInd + 1}>{lColDataList}</tr>);
                                        }

                                        var lEmptyRow = []
                                        lEmptyRow.push(<td key={lrcInd++}/> );
                                        lEmptyRow.push(<td key={lrcInd++}/> );
                                        lEmptyRow.push(<td key={lrcInd++}/> );
                                        lEmptyRow.push(<td key={lrcInd++}/> );
//                                        lEmptyRow.push(<td key={lrcInd++}/> );
                                        lEmptyRow.push(<td key={lrcInd++}/> );
                
                                        lDataCollection.push(<tr key={lDataCollection.length + 1}>{lEmptyRow}</tr>);

                                        var lTotalRow = []
                                        lTotalRow.push(<td key={lrcInd++} colSpan="4" align='right'> Total Quantity</td> );
                                        lTotalRow.push(<td key={lrcInd++} align='right'>{lTotalQuantity}</td> );
                
                                        lDataCollection.push(<tr key={lDataCollection.length + 1}>{lTotalRow}</tr>);
                
                                        setGoodsReceiptItems(lDataCollection);
                                    }
                                }
                            }
                        );
                    }
                }
            }

            fnInitializeData();
        }, [mServiceCode, mRequestId, lProps.pCriteria]
    );

    var lHeaderActions = [];
    lHeaderActions.push(
        <ReactToPrint
            key = "1"
            trigger={() => 
                <Button
                    style=
                        {
                            {
                                fontSize        : '13.2px', 
                                marginRight     : '.35em', 
                                width           : '24px', 
                                height          : '24px',
                                verticalAlign   : 'middle'
                            }
                        } 
                        type="Button" 
                        icon={CSUtil.mNameIconMap['PI_PRINT']} 
                    />
                }
            content={() => mComponentRef.current}
        />
    );
        
    lHeaderActions.push(
        <Button
            key = "2"
            style=
                {
                    {
                        fontSize        : '13.2px', 
                        marginRight     : '.35em', 
                        width           : '24px', 
                        height          : '24px',
                        verticalAlign   : 'middle'
                    }
                } 
            type="Button" 
            icon={CSUtil.mNameIconMap['PI_TIMES']}
            onClick= { () => (lProps.fnEnablePrint) ? lProps.fnEnablePrint(false) : null }
        />
    );

    var lHeader = 
        <>
            <div className="p-toolbar-group-left">
                <h2>{lProps.pFormHeading}</h2>
            </div>

            <div className="p-toolbar-group-right">
                { lHeaderActions }
            </div>
        </>

    const lForm = 
        <div id="po1" ref={mComponentRef} className="po1">
            <div style={{minWidth: '600px'}}>
                <header>
                    <div className="row">
                        <div className="logo">
                            <img
                                src={ mCompanyDetails.mLogo } 
                                width="100%"
                                alt=""/>
                        </div>

                        <div className="company-details">
                            <h2 className="name">
                                { mCompanyDetails.mCompanyName }
                            </h2>

                            <div>
                                { mCompanyDetails.mAddress1 }
                            </div>

                            <div>
                                { mCompanyDetails.mAddress2 }
                            </div>
                        </div>
                
                        <div className="company-contact">
                            <div>Tel No. : { mCompanyDetails.mPhone1 }</div>
                            <div>Tel No. : { mCompanyDetails.mPhone2 }</div>
                            <div>Website : { mCompanyDetails.mWebsite }</div>
                            <div>EMail   : { mCompanyDetails.mEmail }</div>
                        </div>
                    </div>
                </header>

                <main>
                    <div className="title">
                        <h1>{ mFormTitle }</h1>
                    </div>

                    <div className="sum-1">
                        <div className="summary-1">
                            <h3 className="summary-title">
                                { mConsigneeDetails.mTitle }
                            </h3>
                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>Name</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mConsigneeDetails.mConsigneeName}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>Address</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mConsigneeDetails.mAddress}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}/>
                                <div style={{width: '25px', fontWeight: 'bold'}}/>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>Contact Person</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mConsigneeDetails.mContactPerson}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>EMail</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mConsigneeDetails.mEmail}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>GSTIN</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mConsigneeDetails.mGstNo}</div>
                            </div>
                        </div>

                        <div className="summary-2">
                            <h3 className="summary-title">
                                { mVendorDetails.mTitle }
                            </h3>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>M/S</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mVendorDetails.mVendorName}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>Address</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mVendorDetails.mVendorAddress}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}/>
                                <div style={{width: '100%'}} />
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>Contact Person</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mVendorDetails.mContactPerson}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>Phone No</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mVendorDetails.mContactNumber}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>GSTIN</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mVendorDetails.mGstNo}</div>
                            </div>
                        </div>
                    </div>

                    <div className="sum-1">
                        <div className="summary-1">
                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>GRN Number</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mGoodsReceipt.mGoodsReceiptNo}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>GRN Date</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mGoodsReceipt.mGoodsReceiptDate}</div>
                            </div>
                        </div>
                                
                        <div className="summary-2">
                        <div className="form-item-row"> 
                                <div style={{width: '125px'}}>Vendor DC No</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mGoodsReceipt.mVendorDcNo}</div>
                            </div>

                            <div className="form-item-row"> 
                                <div style={{width: '125px'}}>PO Nos</div>
                                <div style={{width: '25px', fontWeight: 'bold'}}>:&nbsp;&nbsp;</div>
                                <div style={{width: '100%'}}>{mGoodsReceipt.mPOList}</div>
                            </div>
                        </div>
                    </div>

                    <>
                        <h3 className="order-details-title">
                            { mGoodsReceipt.mGRNTitle }
                        </h3>

                        <div className="order-details">
                            <table className="items">
                                <thead>
                                    <tr>
                                        <th>SNo              </th>
                                        <th>SKU Code         </th>
                                        <th>Item Name        </th>
                                        <th>Item Description </th>
                                        { /* <th>Order Quantity   </th> */ }
                                        <th>Receipt Quantity </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { mGoodsReceiptItems }
                                </tbody>
                            </table>
                        </div>
                    </>
                </main>
                
                <footer>
                    { mFooter }
                </footer>
            </div>

            <div></div>
        </div>

    return (
        <Dialog
            visible   = {true} 
            minheight = 'auto'
            closable  = {false}
            header    = {lHeader}
            appendTo  = { document.body }
            onHide    = { () => (lProps.fnEnablePrint) ? lProps.fnEnablePrint(false) : null }>
                { lForm }
        </Dialog>
    );
}

export default CSGoodsReceipt1;